let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hHrTM")).then(() => parcelRequire('2MNkP'));